<template>
    <div>
        <app-finalizacao :finalizacao="finalizacao">
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </app-finalizacao>
        <app-desp-viagens
            :incluirSelecao="true"
            :despViagens="despViagensDisponiveis"
            titulo="Despesa de Viagens Disponíveis"
        >
            <template slot="botoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="primary"
                        @click="confirmaAssociarSelecionadas()"
                        :disabled="
                            despViagensDisponiveisSelecionadas.length === 0
                        "
                        >Associar selecionadas</b-button
                    >
                </b-button-group>
            </template>
            <template slot="despViagemSelecao" slot-scope="data">
                <b-form-checkbox
                    :value="data.despViagemCod"
                    v-model="despViagensDisponiveisSelecionadas"
                ></b-form-checkbox>
            </template>
        </app-desp-viagens>
    </div>
</template>

<script>
import Finalizacao from './FinalizacaoDetalhar'
import DespViagens from './../despviagens/DespViagens'

export default {
    props: {
        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        },

        finalizacao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            despViagensDisponiveisSelecionadas: [],
            despViagensDisponiveis: []
        }
    },

    methods: {
        obterDespViagensDisponiveis() {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos
                .obterDespViagensDisponiveis(this.$route.params.finalizacaoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.despViagensDisponiveis = response.data
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        confirmaAssociarSelecionadas() {
            this.$swal({
                title: 'Associar Despesas de Viagens',
                html: `Confirma a associação das despesas de viagens selecionadas?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.associarDespViagens()
                }
            })
        },

        associarDespViagens() {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos
                .associarDespViagens({
                    finalizacaoId: this.$route.params.finalizacaoId,
                    despViagensCod: this.despViagensDisponiveisSelecionadas
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.despViagensDisponiveisSelecionadas = []
                            this.obterDespViagensDisponiveis()
                            this.$emit('obterFinalizacaoAtualizada')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {
        this.obterDespViagensDisponiveis()
    },

    components: {
        AppFinalizacao: Finalizacao,
        AppDespViagens: DespViagens
    }
}
</script>
